module.exports = "<corporate-holiday-page></corporate-holiday-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appCustomers/corporateHoliday.html
// module id = 2073
// module chunks = 0